<template>
    <div>
        <c-search-form
            :rows-per-page-items="[10, 20, 50]"
            :form-name="formName"
            :fields="fields"
            key-property="categoryId"
            search-url="/category/onSearchAllStatus?categoryTypeCode=WAREHOUSE&sortField=createAt&"
            create-url="/category/save"
            delete-url="/category/delete"
            form-type="intable"
            custom-create-new
            @createNew="openCreateDialog"
            custom-edit-item
            @editItem="openCreateDialog"
            ref="tableData"
            :reload="timeReload"
            :isPagination="false"
            :deleteMulti="false"
            orderBy="desc"
            :acceptDelete="false"
        >
        </c-search-form>
        <warehouse-create
            :propsItem="category"
            :cDialog="visibleCreateDialog"
            :pondAreas="pondAreas"
            @closeCreateDialog="closeCreateDialog"
            :formCreateName="formCreateName"
        />
    </div>
</template>

<script>
import CSearchForm from "../../../components/form/ManageForm";
import WarehouseCreate from "./WarehouseCreate.vue";
import axios from "axios";
import { areaContants } from "@/constants";

export default {
    name: "warehouse",
    components: { WarehouseCreate, CSearchForm },
    data: () => {
        return {
            formName: "Danh sách kho",
            formCreateName: "Thêm mới kho",
            category: null,
            visibleCreateDialog: false,
            timeReload: 0,
            pondAreas: [],
            fields: [
                {
                    value: "index",
                    text: "lang.common.index",
                    width: "10%",
                    sortable: false,
                    headerStyle: "text-align:center",
                },
                {
                    value: "categoryCode",
                    text: "Mã kho",
                    sortable: false,
                    search: true,
                    headerStyle: "text-align:center",
                },
                {
                    value: "categoryName",
                    text: "Tên kho",
                    sortable: false,
                    search: true,
                    headerStyle: "text-align:center",
                },
                {
                    value: "parentId",
                    text: "Khu nuôi",
                    sortable: false,
                    search: true,
                    headerStyle: "text-align:center",
                    type: "select",
                    name: 'parentId',
                    items: [],
                    itemText: "categoryCode",
                    itemValue: "categoryId",
                },
                {
                    value: "status",
                    text: "lang.user.status",
                    search: true,
                    headerStyle: "text-align:center",
                    type: "select",
                    name: "status",
                    items: areaContants.areaStatus,
                    itemText: "text",
                    itemValue: "value",
                },
                {
                    value: "action",
                    text: "lang.common.actions",
                    sortable: false,
                    compound: true,
                    width: "60px",
                    headerStyle: "text-align:center",
                },
            ],
        };
    },

    created() {
        // pondArea
        axios.post(
                process.env.VUE_APP_API_URL + "/category/listByType?type=PONDAREA", {status: 1}
            )
            .then(
                (data) => {
                    if (data.length > 0) {
                        this.pondAreas = data;
                        let itemFields = this.fields.filter(function (e) {
                            return e.name == "parentId";
                        });
                        if (itemFields != undefined && itemFields.length > 0) {
                            itemFields[0].items = data;
                        }
                    }
                }
            );
    },

    methods: {
        openCreateDialog: function (item = null) {
            if (item == null) {
                this.formCreateName = 'Thêm mới kho';
                this.getNextCode();
            } else {
                this.category = item;
                this.formCreateName = 'Cập nhật kho';
                this.visibleCreateDialog = true;
            }
        },
        closeCreateDialog: function () {
            this.category = null;
            this.visibleCreateDialog = false;
            this.timeReload = Math.floor(Math.random() * 100);
        },
        getNextCode: function () {
            axios.get(
                process.env.VUE_APP_API_URL +
                "/autoIncrease/getNextCode?type=KHO&prefix=KHO&numberZeroBeforeCodeNumberCode=1&suffix="
            )
                .then((data) => {
                    this.category = Object.assign({}, this.category, {"categoryCode": data, "status": 1})
                    this.visibleCreateDialog = true;
                });
        },
    },

    destroyed() {},
};
</script>
